import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IGetOrganization, IGetOrganizationConfig, IPatchOrganizationConfig} from "@core/http/configuration/interfaces/organization-config.interface";
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IOrganizationUserConfig, IPostUserConfig, IUserConfig } from './interfaces/user-config.interface';
import { userConfig } from '../graphic/interfaces/userConfig.interface';
import { ILocationInformation } from '../time-zone/interfaces/server-time.interface';

@Injectable({
  providedIn: 'root'
})
export class OrganizationConfigurationService {

  /**
   * Tiene la configuracion de "Tener todos los dispositivos de un mismo tipo sin repetirse" en la organizacion
   */
  private agentsConfig: IGetOrganizationConfig[] = [{
    organization_id: "GCA",
    key: "multiple_assignments",
    value: "2",
    type: "DEVICE"
  }];

  /**
   * Tiene la configuracion de "Un dispositivo solo se puede asignar a un agente" en la organizacion
  */
  private devicesConfig: IGetOrganizationConfig[] = [{
    organization_id: "GCA",
    key: "multiple_assignments",
    value: "1",
    type: "DEVICE"
  }];
  private GATEWAY_URL: string = environment.GATEWAY_URL;

  constructor(private http: HttpClient) { }

  public getAllOrganizations() {
    return this.http.get<IGetOrganization[]>(`${this.GATEWAY_URL}/organizations`)
  }

  public getAgentsOrganizationConfig(): IGetOrganizationConfig[] {
    return this.agentsConfig;
  }

  public getDevicesOrganizationConfig(): IGetOrganizationConfig[] {
    return this.devicesConfig;
  }

  public getInitialCoordinates() : {latitude: number, longitude: number} {
    const initial_coordinates = environment.INITIAL_COORDINATES
    return initial_coordinates
  }

  public getBatchConfig(organizationId: string, key: string) {
    return this.http.get<IGetOrganizationConfig[]>(`${this.GATEWAY_URL}/organization/${organizationId}/config?key=${key}`)
  }

  public getOrganizationConfig(organizationId: string, filter?: string): Observable<IGetOrganizationConfig[]> {
    let params = new HttpParams();
    if (filter) {
      params = params.append('key', filter);
    }
    return this.http.get<IGetOrganizationConfig[]>(`${this.GATEWAY_URL}/organization/${organizationId}/config`, {params});
  }

  public getOrganization(id: string): Observable<IGetOrganization> {
    return this.http.get<IGetOrganization>(`${this.GATEWAY_URL}/organizations/${id}`)
  }

  public getDescendantsFromOrganization(id: string) {
    return this.http.get<string[]>(`${this.GATEWAY_URL}/organization/${id}/descendants`)
  }

  public updateOrganization(organizationId: string, data: FormData): Observable<IGetOrganization> {
    return this.http.patch<IGetOrganization>(`${this.GATEWAY_URL}/organizations/${organizationId}`, data)
  }

  public getOrganizationUserConfig(organizationId: string, userId: string): Observable<IOrganizationUserConfig[]> {
    return this.http.get<IOrganizationUserConfig[]>(`${this.GATEWAY_URL}/organization/${organizationId}/user/${userId}/config`)
  }

  public getSpecificUserConfig(userId: string, key: string) {
    return this.http.get<IUserConfig[]>(`${this.GATEWAY_URL}/user/${userId}/config?key=${key}`)
  }

  public createUserConfig(userId: string, body: any) {
    return this.http.post<IPostUserConfig>(`${this.GATEWAY_URL}/user/${userId}/config`, body)
  }

  public updateSpecificUserConfig(userId: string, key: string, body: any) {
    return this.http.patch<IUserConfig>(`${this.GATEWAY_URL}/user/${userId}/config/${key}`, body)
  }

  // SERVICIO ORGANIZACION
  public updateOrganizationConfig(organizationId: string, data: IPatchOrganizationConfig[]): Observable<IGetOrganizationConfig[]> {
    return this.http.patch<IGetOrganizationConfig[]>(`${this.GATEWAY_URL}/organization/${organizationId}/config`, data)
  }

  // SEVICIO DE USUARIO
  public updateConfigurationUsers(idOrganization: string, user: string, data: any): Observable<any> {
    return this.http.patch<userConfig>(`${this.GATEWAY_URL}/organization/${idOrganization}/userId/${user}/config`, data);
  }

}
